import en from "./en";
import fr from "./fr";
import nl from "./nl";
var languageList = { nl: nl, en: en, fr: fr };
export default languageList;
